import { APIConnector, Settings } from "../base";

const apiConnector = new APIConnector({ timeout: 40000 });

export default class DataConfig {
	static get base() {
		return Settings.server + "/data";
	}

	static get endpointCivilStatus() {
		return `${DataConfig.base}/civilstatus`;
	}

	static get endpointGenders() {
		return `${DataConfig.base}/genders`;
	}

	static get endpointNationalities() {
		return `${DataConfig.base}/nationalities`;
	}

	static get endpointGetRol() {
		return `${DataConfig.base}/rol`;
	}

	static get endpointRelationship() {
		return `${DataConfig.base}/relationship`;
	}

	static get endpointAffiliateStatusCantNow() {
		return `${DataConfig.base}/affiliateStatusCantNow`;
	}

	static get APIConnector() {
		return apiConnector;
	}
}



// WEBPACK FOOTER //
// ./src/provider/Data/DataConfig.js